import { useContext } from 'react';
import { PermissionContext } from 'context/PermissionContext';

const usePermissionContext = () => {
  const ctx = useContext(PermissionContext);
  return { ...ctx };
};

export default usePermissionContext;
